import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** `/portal/grupa/:groupId/prezenta` — now a tab of the group page (06.10.2026);
 *  the old address keeps working. */
export default function PortalPresence() {
  const { groupId } = useParams();
  return <Navigate to={`/portal/grupa/${groupId}?fila=prezenta`} replace />;
}
